import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  appBar: {
    position: 'absolute',
  },
  navIconHide: {},
  drawerPaper: {
    width: 250,
  },
  content: {
    width: '100%',
  },
  upperCase: {
    textTransform: 'uppercase',
  },
  noti: {},
}));
